module.exports = __webpack_public_path__ + "e38f66573a19319f86d5caadbb7eb703.webp";